export function getSalesPhaseTitle(phase, language = 'fr') {
  if (!phase) return '';
  if (language === 'it' && phase.titleIt) {
    return phase.titleIt;
  }
  return phase.title || phase.titleIt || '';
}
